import React, { useState } from 'react';
import './key-selection-modal.scss';
import { UiInput } from '@ru-digital-assets/ui-component';
import Modal from 'modules/modal';
import { ReactComponent as KeyIcon } from 'modules/common-icons/Key.svg';
import { ReactComponent as FileIcon } from 'modules/common-icons/file-icon.svg';
import { ReactComponent as KeyStorageIcon } from 'modules/common-icons/key-storage-icon.svg';
import { useAppDispatch } from 'store';
import { setPush } from 'store/actions/app';
import { Wallet } from 'ethers';
import { FileSelectionButton } from 'components';
import { useHistory } from 'react-router';

interface IKeySelectionModal {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (privateKey: string, fileName: string) => void;
}

export default function KeySelectionModal({
  isOpen,
  onClose,
  onSubmit,
}: IKeySelectionModal) {
  const history = useHistory();
  const [file, setFile] = useState<File>();
  const dispatch = useAppDispatch();
  const [privateKey, setPrivateKey] = useState('');
  const aes256 = require('aes256');
  const [encFile, setEncFile] = useState(false);
  const [fileSecret, setFileSecret] = useState('');

  const validationPrivateKey = (data?: string) => {
    let priv = data ? data : privateKey;
    if (encFile) {
      let str = privateKey.substring(4, privateKey.indexOf(')'));
      priv = aes256.decrypt(fileSecret, str).trim();
      if (!priv.startsWith('0x')) {
        dispatch(
          setPush({
            message: 'Некорректный пароль от файла Ключа',
            type: 'error',
          })
        );
        return false;
      }
      setPrivateKey(priv);
    }
    try {
      new Wallet(priv);
    } catch (e) {
      dispatch(
        setPush({
          message:
            'Некорректный формат ключа. Ожидаемый формат 0x... или 64 символа',
          type: 'error',
        })
      );
      return false;
    }
    return priv;
  };

  const onSetFile = (file?: File) => {
    setFile(file);
    if (file) {
      file.text().then((result) => {
        const trimmedResult = result.trim();
        if (trimmedResult.startsWith('ENC(')) {
          setPrivateKey(trimmedResult);
          setEncFile(true);
        } else {
          if (validationPrivateKey(trimmedResult)) {
            setPrivateKey(trimmedResult);
          }
        }
      });
    }
  };

  const parseKey = () => {
    const key = validationPrivateKey();
    if (key) {
      onSubmit(key, file!.name);
      clearKeyData();
    }
  };

  const clearKeyData = () => {
    setPrivateKey('');
    setFileSecret('');
    setEncFile(false);
    setFile(undefined);
  };

  return (
    <div className="key-selection-modal">
      <Modal
        open={isOpen}
        onClose={onClose}
        header={<b>Подписание транзакции</b>}
        body={
          <>
            <div className="flex justify-between mb_24">
              <p className="p">
                Для подписания транзакции загрузите файл
                <br />
                Вашего Ключа:
              </p>
              <KeyIcon />
            </div>
            <div className="mb_24">
              <FileSelectionButton
                label="Файл ключа"
                keyFile
                icon={<FileIcon />}
                onFileChange={onSetFile}
                hoverable
              />
            </div>
            {encFile ? (
              <UiInput
                lg
                type="password"
                placeholder="Введите кодовое слово"
                onChange={(e: React.FormEvent<HTMLInputElement>) => {
                  setFileSecret(e.currentTarget.value);
                }}
              />
            ) : (
              <FileSelectionButton
                label="Выбрать из Keystore"
                keyFile
                icon={<KeyStorageIcon />}
                onFileChange={() => { }}
                hoverable
              />
            )}
            <div className="flex justify-end  mt_4">
              <button
                className="button button_primary button_font-size_12"
                onClick={() => history.push('/restore-key')}
              >
                Нет Ключа? Восстановить
              </button>
            </div>
          </>
        }
        footer={{
          left: (
            <button
              className="button button_secondary"
              onClick={() => {
                onClose();
                clearKeyData();
              }}
            >
              Отмена
            </button>
          ),
          right: (
            <button
              className={`button button_primary ${!privateKey || (encFile && !fileSecret) ? 'button_disabled' : ''
                }`}
              onClick={parseKey}
              disabled={!privateKey || (encFile && !fileSecret)}
            >
              Загрузить Ключ
            </button>
          ),
        }}
      />
    </div>
  );
}
